import React from "react";
import PageContainer from "../../../../hoc/PageContainer";
import "./RIntelligence.css";

import { Image } from 'semantic-ui-react';
import IMG1 from "../../img/1920-service-1/1920-service-1-1-min.jpg";
import IMG2 from "../../img/1920-service-1/1920-service-1-2-min.jpg";
import IMG3 from "../../img/1920-service-1/1920-service-1-3-min.jpg";
import IMG4 from "../../img/1920-service-1/1920-service-1-4-min.jpg";
import IMG5 from "../../img/1920-service-1/1920-service-1-5-min.jpg";

const RIntelligence = () => (
  <PageContainer page="ourServices">
    <h1 className="AboutUsTitle">
      Rotary Club of Central - R-Intelligence (三角智)
    </h1>
    <br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG1} />
    </div>
    <div className="AboutUsText">
      <p>
        R-Intelligence (三角智) was a new service project of Rotary Club of
        Central in RY 2019-2020 targeting “Young Olds” (i.e. retired, mobile and
        energetic people at the age of 50-65) where our club provided a learning
        and social service platform for the golden age individuals. Rotary Club
        of Central provided horticultural therapy workshops to R-Intelligence
        Young Olds and engaged them to join our club’s regular elderly visits.
        The beneficiaries include both the Young Olds volunteers and the elderly
        being visited. R-Intelligence was a service project that accomplished
        the focus of Economic and Community Development out of Rotary’s six
        areas of focus. The aims were to encourage golden age people to continue
        serving the society, to promote prevention of post retirement social
        problem and to uphold the theme of cross-generation harmony to society.
      </p>
    </div>
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG2} />
    </div>
    <br /><br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG3} />
    </div>
    <br /><br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG4} />
    </div>
    <br /><br />
    <div className="AboutUsImage">
      <Image className="AboutUsImage" src={IMG5} />
    </div>
    <br /><br />
  </PageContainer>
);

export default RIntelligence;
